import { useMemo, useState } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Button } from "@mui/material";
import { useGet } from "../../hooks/api-call";
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as XLSX from "xlsx";
import { makeApiRequest } from "../../hooks/helper";
import { useAuth } from "../../auth/AuthProvider";
import TripDetailModal from "./TripDetailPopup";

const TripHistoryList = ({ isTrips }) => {
    const [openPopup, setPopup] = useState(false);
    const [failedData, setFailedData] = useState([]);

    const { token } = useAuth();

    const { responseData } = useGet("bulk/job/history");

    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const handleDownload = async (jobId) => {
        try {
            const responseData = await makeApiRequest("GET", `bulk/job/${jobId}`, null, headers || {});

            if (Array.isArray(responseData) && responseData.length > 0) {
                const rows = [];
                if (isTrips) {
                    responseData.forEach((item) => {
                        const rawannaNo = item.validationErrors?.rawannaNo || `ID-${item.id}`;
                        const errors = item.validationErrors?.errors || [];

                        if (errors.length > 0) {
                            const row = { rawannaNo };
                            errors.forEach((error, index) => {
                                row[`Error ${index + 1}`] = error;
                            });
                            rows.push(row);
                        }
                    });
                }
                else {
                    // For trucks, we assume the structure is similar
                }

                if (rows.length === 0) {
                    alert("No validation errors to download.");
                    return;
                }

                const worksheet = XLSX.utils.json_to_sheet(rows);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "ValidationErrors");
                XLSX.writeFile(workbook, `Job_${jobId}_ValidationErrors.xlsx`);
            }
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    const handleCloseModal = () => {
        setPopup(!openPopup);        
    }

    const handlePreview = async (jobId) => {
        try {
            const responseData = await makeApiRequest("GET", `bulk/job/${jobId}`, null, headers || {});
            const failedData = responseData?.filter(item => item?.status === "FAILED");
            
        } catch (error) {
            console.error("Preview error:", error);
        }
    };


    const columns = useMemo(
        () => [
            {
                accessorKey: "id",
                header: "Job Id"
            },
            {
                accessorKey: "status",
                header: "Status",
            },
            {
                accessorKey: "totalRows",
                header: "Total No. Of Trips",
            },
            {
                accessorKey: "validCount",
                header: "Succeed",
            },
            {
                accessorKey: "invalidCount",
                header: "Failed",
            },
            {
                accessorKey: "Preview",
                header: isTrips ? "Preview Failed Trip" : "Preview Failed Truck",
                Cell: ({ cell }) => (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        {cell.row.original.invalidCount > 0 ? (
                            <Button
                                onClick={() => handlePreview(cell.row?.original?.id)}
                                variant="text"
                                color="primary"
                            >
                                <VisibilityIcon />
                            </Button>
                        ) : <div>-</div>}
                    </div>
                ),
            },
            {
                accessorKey: "Failed",
                header: isTrips ? "Download Failed Trip" : "Download Failed Truck",
                Cell: ({ cell }) => (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        {cell.row.original.invalidCount > 0 ? (
                            <Button
                                onClick={() => handleDownload(cell.row?.original?.id)}
                                variant="text"
                                color="primary"
                            >
                                <DownloadIcon />
                            </Button>
                        ) : <div>-</div>}
                    </div>
                ),
            }
        ],
        []
    );

    const filterByEvent = isTrips ? "TRIP_UPLOAD" : "TRUCK_UPLOAD";

    const tripHistoryList = (responseData || []).filter(v => v?.eventName === filterByEvent).sort((a, b) => a.id - b.id);

    const table = useMaterialReactTable({
        columns,
        data: tripHistoryList || [],
        enableColumnPinning: true,
        enableSorting: false,
        manualFiltering: true,
        manualPagination: true,
        initialState: { density: "compact", pagination: { pageIndex: 0, pageSize: 20 } },
        muiPaginationProps: {
            rowsPerPageOptions: [20, 25, 50, 100],
            showFirstButton: true,
            showLastButton: true,
            sx: {
                "& .Mui-selected": {
                    backgroundColor: "primary.main",
                    color: "white",
                },
            },
        },
        paginationDisplayMode: "pages",
        muiTableBodyRowProps: ({ staticRowIndex }) => ({
            sx: {
                backgroundColor: staticRowIndex.index % 2 === 0 ? "white" : "grey.100",
            },
        }),
    });

    return (
        <>
            <MaterialReactTable table={table} />
            {openPopup && <TripDetailModal openPopup={openPopup} handleCloseModal={handleCloseModal}/>}
        </>
    );
};

export default TripHistoryList;